// extracted by mini-css-extract-plugin
export default {"navlink":"global_navigation_navlink__39e4V"};